import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createSearchEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackSearchOpen = (source: PosthogTrackingSource) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.SEARCH_OPEN,
      properties: { source },
    });

  return { trackSearchOpen };
};
